var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('triangle');
import { breakpoints, theme } from '@shapeable/theme';
export var TriangleDefaultProps = {
  size: 10,
  direction: 'down',
  color: '#000000'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: block;\n    width: 0;\n    height: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "], ["\n    display: block;\n    width: 0;\n    height: 0;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var _width = _a._width,
        _height = _a._height,
        _color = _a._color,
        direction = _a.direction;
    return direction === 'up' && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-left: ", "px solid transparent;\n      border-right: ", "px solid transparent;\n      border-bottom: ", "px solid ", ";\n    "], ["\n      border-left: ", "px solid transparent;\n      border-right: ", "px solid transparent;\n      border-bottom: ", "px solid ", ";\n    "])), _width, _width, _height, theme.COLOR(_color));
  }, function (_a) {
    var _width = _a._width,
        _height = _a._height,
        _color = _a._color,
        direction = _a.direction;
    return direction === 'down' && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-left: ", "px solid transparent;\n      border-right: ", "px solid transparent;\n      border-top: ", "px solid ", ";\n    "], ["\n      border-left: ", "px solid transparent;\n      border-right: ", "px solid transparent;\n      border-top: ", "px solid ", ";\n    "])), _width, _width, _height, theme.COLOR(_color));
  }, function (_a) {
    var _width = _a._width,
        _height = _a._height,
        _color = _a._color,
        direction = _a.direction;
    return direction === 'right' && css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border-top: ", "px solid transparent;\n      border-bottom: ", "px solid transparent;\n      border-left: ", "px solid ", ";\n    "], ["\n      border-top: ", "px solid transparent;\n      border-bottom: ", "px solid transparent;\n      border-left: ", "px solid ", ";\n    "])), _width, _width, _height, theme.COLOR(_color));
  }, function (_a) {
    var _width = _a._width,
        _height = _a._height,
        _color = _a._color,
        direction = _a.direction;
    return direction === 'left' && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      border-top: ", "px solid transparent;\n      border-bottom: ", "px solid transparent;\n      border-right: ", "px solid ", ";\n    "], ["\n      border-top: ", "px solid transparent;\n      border-bottom: ", "px solid transparent;\n      border-right: ", "px solid ", ";\n    "])), _width, _width, _height, theme.COLOR(_color));
  })
}); // -------- Components -------->

var My = {
  Container: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Triangle = function Triangle(props) {
  var className = props.className,
      color = props.color,
      size = props.size,
      width = props.width,
      height = props.height,
      direction = props.direction;
  return React.createElement(My.Container, {
    direction: direction,
    _width: width || size,
    _height: height || size,
    _color: color,
    className: cls.name(className)
  });
};
Triangle.defaultProps = TriangleDefaultProps;
Triangle.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;